import { cn } from "@aurem/ui";
import { Link, useLocation } from "react-router-dom";
import { NavLink } from "./types";

type Props = {
  navLinks: NavLink[];
};

export const ControlsNavList = ({ navLinks }: Props) => {
  const { pathname } = useLocation();

  return (
    <ul className="flex flex-col text-sm gap-1">
      {navLinks.map(({ label, to, disabled }) => {
        const isActive = pathname.endsWith(to);

        return (
          <li
            key={to}
            className={cn(
              "p-3 rounded-lg transition-colors",
              !disabled && !isActive && "hover:bg-[rgba(0,0,0,0.03)]",
              isActive && "bg-neutral-500/5",
            )}
          >
            {disabled ? (
              <span className="text-neutral-500/30 block">{label}</span>
            ) : (
              <Link to={to} className="block">
                {label}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};
